import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import PickerLocale from "@bedrock/date-picker/es/locale/en_US";

function getDefaultFormat(format, picker, showTime, use12Hours) {
  var mergedFormat = format;

  if (!mergedFormat) {
    switch (picker) {
      case 'time':
        mergedFormat = use12Hours ? 'hh:mm:ss a' : 'HH:mm:ss';
        break;

      case 'week':
        mergedFormat = 'YYYY--[W]w';
        break;

      case 'month':
        mergedFormat = 'gggg-wo';
        break;

      case 'quarter':
        mergedFormat = 'YYYY-[Q]Q';
        break;

      case 'year':
        mergedFormat = 'YYYY';
        break;

      default:
        mergedFormat = showTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
    }
  }

  return mergedFormat;
}

var messages = _objectSpread(_objectSpread({}, PickerLocale), {}, {
  timeSelectPlaceholder: 'Select time',
  dateSelectPlaceholder: 'Select date',
  monthSelectPlaceholder: 'Select month',
  quarterSelectPlaceholder: 'Select quarter',
  yearSelectPlaceholder: 'Select year',
  rangeTimeSelectPlaceholder: ['Start time', 'End time'],
  rangeDateSelectPlaceholder: ['Start date', 'End date'],
  rangeMonthSelectPlaceholder: ['Start month', 'End month'],
  rangeQuarterSelectPlaceholder: ['Start quarter', 'End quarter'],
  rangeYearSelectPlaceholder: ['Start year', 'End year'],
  // monthFormat: 'M月',
  // shortWeekDays: ['日', '一', '二', '三', '四', '五', '六'],
  // weekFormat: 'YYYY年-w周',
  getDefaultFormat: getDefaultFormat
});

export default messages;